export type Nadruk = 'hoofd' | 'gewoon' | 'stil' | 'gevaar';

const stijlen: Record<Nadruk, string> = {
  hoofd: 'bg-accent text-accent-tekst active:brightness-90',
  gewoon: 'bg-vlak-hoog text-tekst border border-rand active:bg-vlak',
  stil: 'bg-transparent text-tekst-zacht active:text-tekst',
  gevaar: 'bg-fout text-tekst active:brightness-90',
};

// Zijruimte en tekstmaat die een aanroeper zelf kan kiezen.
const EIGEN_PADDING = /(^|\s)(p|px|pl|pr)-\S/;
const EIGEN_TEKSTMAAT = /(^|\s)text-(xs|sm|base|lg|xl|[2-9]xl)(\s|$)/;

/**
 * De klassen van een knop. De standaardmaat (`px-6`, `text-xl`) komt er alleen bij
 * als de aanroeper geen eigen maat meegeeft.
 *
 * Waarom niet gewoon allebei erbij zetten: Tailwind zet zijn klassen in de CSS op
 * alfabetische volgorde, niet in de volgorde waarin je ze schrijft. `text-xl`
 * staat daardoor na `text-base`, `text-lg` en `text-2xl` en wint van elke
 * afwijking, en `px-6` wint van `px-0` tot `px-5`. Zo bleef "Uitloggen" op de
 * kassa te groot en zou een plus- of minknop van `w-16 px-0` opeens 48 pixels
 * zijruimte krijgen (gevonden 21 september 2026).
 */
export function knopKlassen(nadruk: Nadruk, className = ''): string {
  return [
    'min-h-raakvlak rounded-tegel font-semibold transition-none disabled:opacity-40',
    EIGEN_PADDING.test(className) ? '' : 'px-6',
    EIGEN_TEKSTMAAT.test(className) ? '' : 'text-xl',
    stijlen[nadruk],
    className,
  ]
    .filter((klasse) => klasse !== '')
    .join(' ');
}
